export const ageMethod = "age nearest";
export const gateway = "https://wpg-plan-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/wpg-plan";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ3cGctcGxhbiIsIm5hbWUiOiJ3cGctcGxhbiIsImlhdCI6MTc4MzUzOTIzMCwiZXhwIjoxOTQxMzI3MjMwfQ.INSFXteMWkEjEkllAN_qFdvPukh3MBb5KqDYnYtUya4";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"wpg-plan.link.wawanesalife.com": {
		a: {
			approve_company: "MANITOBA",
			approve_user: "link_wpg-plan",
			brands: [
				"wpg-plan.link.wawanesalife.com",
			],
			broker: "wpg-plan",
			broker_formatted_name: "The Wealth Planning Group",
			email: "insurance@wpg-plan.com",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1.204.989.7676",
			privacyLink: "https://wpg-plan.com/privacy",
			website: "https://wpg-plan.com/",
			scope: "wpg-plan#branding#wpg-plan.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "wpg-plan.link.wawanesalife.com",
		},
		b: {
			approve_company: "MANITOBA",
			approve_user: "link_wpg-plan",
			brands: [
				"wpg-plan.link.wawanesalife.com",
			],
			broker: "wpg-plan",
			broker_formatted_name: "The Wealth Planning Group",
			email: "insurance@wpg-plan.com",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1.204.989.7676",
			privacyLink: "https://wpg-plan.com/privacy",
			website: "https://wpg-plan.com/",
			scope: "wpg-plan#branding#wpg-plan.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "wpg-plan.link.wawanesalife.com",
		},
	},
};

//updated on Wed Jul 08 2026 14:33:50 GMT-0500 (Central Daylight Time)
